'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeCustomDataPageIcon = ({ sx = {} }) => {
  const color1 = sx?.color1 || '#d8dce5'
  const color2 = sx?.color2 || '#5073c3'

  return (
    <SvgIcon sx={sx} data-testid="LargeCustomDataPageIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 90 90"
        id="Drop-Down-List--Streamline-Core"
        height="90"
        width="90"
      >
        <desc>Drop Down List Streamline Icon: https://streamlinehq.com</desc>
        <g id="drop-down-list--drop-down-list-form-web-choice">
          <path
            id="Union"
            fill={color1}
            fillRule="evenodd"
            d="M14.464285714285715 3.2142857142857144C8.251071428571429 3.2142857142857144 3.2142857142857144 8.251071428571429 3.2142857142857144 14.464285714285715v61.07142857142858c0 6.213214285714286 5.036785714285714 11.25 11.25 11.25h61.07142857142858c6.213214285714286 0 11.25 -5.036785714285714 11.25 -11.25v-61.07142857142858c0 -6.213214285714286 -5.036785714285714 -11.25 -11.25 -11.25h-61.07142857142858Z"
            clipRule="evenodd"
            strokeWidth="6.4286"
          ></path>
          <path
            id="Union_2"
            fill={color2}
            fillRule="evenodd"
            d="M3.2142857142857144 14.464285714285715C3.2142857142857144 8.251071428571429 8.251071428571429 3.2142857142857144 14.464285714285715 3.2142857142857144h61.07142857142858c6.213214285714286 0 11.25 5.036785714285714 11.25 11.25V32.142857142857146H3.2142857142857144V14.464285714285715ZM57.85714285714286 12.053571428571429c-1.30005 0 -2.472107142857143 0.7831285714285714 -2.969614285714286 1.9842428571428572 -0.49750714285714287 1.2011142857142858 -0.22249285714285716 2.5835785714285717 0.6967928571428572 3.5028642857142858l6.428571428571429 6.428571428571429c1.255242857142857 1.255307142857143 3.290464285714286 1.255307142857143 4.545964285714286 0l6.428571428571429 -6.428571428571429c0.9192857142857143 -0.9192857142857143 1.1937857142857144 -2.3017499999999997 0.6962142857142857 -3.5028642857142858 -0.49757142857142855 -1.2011142857142858 -1.6695 -1.9842428571428572 -2.969357142857143 -1.9842428571428572H57.85714285714286ZM19.285714285714285 49.82142857142858c0 -2.662778571428572 2.1586499999999997 -4.821428571428571 4.821428571428571 -4.821428571428571h41.785714285714285c2.662714285714286 0 4.821428571428571 2.1586499999999997 4.821428571428571 4.821428571428571s-2.158714285714286 4.821428571428571 -4.821428571428571 4.821428571428571h-41.785714285714285c-2.662778571428572 0 -4.821428571428571 -2.1586499999999997 -4.821428571428571 -4.821428571428571ZM24.107142857142858 64.28571428571429c-2.662778571428572 0 -4.821428571428571 2.158714285714286 -4.821428571428571 4.821428571428571s2.1586499999999997 4.821428571428571 4.821428571428571 4.821428571428571h19.285714285714285c2.662778571428572 0 4.821428571428571 -2.158714285714286 4.821428571428571 -4.821428571428571S46.055635714285714 64.28571428571429 43.392857142857146 64.28571428571429h-19.285714285714285Z"
            clipRule="evenodd"
            strokeWidth="6.4286"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

LargeCustomDataPageIcon.propTypes = {
  sx: PropTypes.object,
  color1: PropTypes.string,
  color2: PropTypes.string
}
